// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kd-0";
export var fileCarousel = "_kd-2";
export var removeFileButton = "_kd-1";